'use client';
import { RewardPoints } from '@capsicum/common';
import styled from 'styled-components';
import { match } from 'ts-pattern';

import { Image } from '../../atoms/image/Image';

export type SsuHudProps = {
	children: number;
	size?: 'large' | 'small' | 'xsmall';
	testID: string;
};

export const SsuHud = ({ children, size = 'large', testID, ...props }: SsuHudProps) => {
	const sizePx = match(size)
		.with('xsmall', () => 16)
		.with('small', () => 27)
		.otherwise(() => 32);

	return (
		<S.SsuHudWrapper {...props} data-testid={testID}>
			<Image alt="reward points logo" height={sizePx * 0.75} src={RewardPoints} width={sizePx} />
			<S.Amount $size={size}>{children}</S.Amount>
		</S.SsuHudWrapper>
	);
};
namespace S {
	export const SsuHudWrapper = styled.div`
		display: flex;
		align-self: center;
		align-items: center;
		background-color: ${({ theme }) => theme.colors.backgrounds.main.subtle};
		${({ theme }) => theme.border.radius.circle};
		width: fit-content;
		padding: ${({ theme }) => `0 ${theme.spacings.xxsmall} 0 0`};
	`;

	export const Amount = styled.div<{ $size: SsuHudProps['size'] }>`
		${({ $size, theme }) =>
			$size === 'xsmall'
				? theme.fonts.text.caption1
				: $size === 'small'
					? theme.fonts.text.text1
					: theme.fonts.headings.title6};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		margin-left: ${({ theme }) => theme.spacings.xxxsmall};
	`;
}
